import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
import { generateUrl, getTeamSlugById } from '@fede/utils';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { getParentSibling, getNextSibling } from '../scripts/accessibility';
var LoginMenu = function LoginMenu(_ref) {
  var _cx;
  var clubId = _ref.clubId,
    isClub = _ref.isClub,
    isLoginMenuOpen = _ref.isLoginMenuOpen,
    locale = _ref.locale,
    mouseLeaveHandler = _ref.mouseLeaveHandler,
    onLogout = _ref.onLogout,
    useInlineLogout = _ref.useInlineLogout;
  var clubPath = isClub && getTeamSlugById(parseInt(clubId, 10));
  var ACCOUNT_LINKS = [{
    enCopy: 'Account Settings',
    esCopy: 'Configuraciones de Cuenta',
    link: generateUrl({
      basePath: '/account/general',
      clubPath: clubPath,
      lang: locale,
      rootRelative: true
    })
  }, {
    enCopy: 'My Players & Teams',
    esCopy: 'Mis Jugadores y Equipos',
    link: generateUrl({
      basePath: '/account/favorites',
      clubPath: clubPath,
      lang: locale,
      rootRelative: true
    })
  }, {
    enCopy: 'Manage Subscriptions',
    esCopy: 'Manejar Subscripciones',
    link: generateUrl({
      basePath: '/account/subscriptions',
      clubPath: clubPath,
      lang: locale,
      rootRelative: true
    })
  }, {
    enCopy: 'Email Newsletters',
    esCopy: 'Boletines Electrónicos',
    link: generateUrl({
      basePath: '/account/email-subscription',
      clubPath: clubPath,
      lang: locale,
      rootRelative: true
    })
  }];
  var loginMenuClassName = 'mlb-header__login-menu';
  var firstMenuLink = useRef(null);
  useEffect(function () {
    if (isLoginMenuOpen) {
      firstMenuLink.current.focus();
    }
  }, [isLoginMenuOpen]);
  var loginMenuClasses = cx((_cx = {}, _defineProperty(_cx, loginMenuClassName, true), _defineProperty(_cx, "".concat(loginMenuClassName, "--open"), isLoginMenuOpen), _cx));
  var handleKeyDown = function handleKeyDown(event) {
    var keyCode = event.keyCode;
    var escape = 27;
    var upArrow = 38;
    var downArrow = 40;
    var currentDomEl = event.target;
    if (keyCode === escape && isLoginMenuOpen) {
      setTimeout(function () {
        mouseLeaveHandler();
        document.querySelector('.account--logged-in').focus();
      }, 1000);
    } else if (keyCode === downArrow || keyCode === upArrow) {
      event.preventDefault(); // disable page scrolling
      var direction = keyCode === downArrow ? 'next' : 'previous';
      var nextElement = getNextSibling(currentDomEl, direction) || getParentSibling(currentDomEl, 'previous');
      if (nextElement) {
        nextElement.focus();
      }
    }
  };
  var renderLogout = function renderLogout() {
    var _window, _window$location;
    var commonProps = {
      className: cx({
        'mlb-header__login-menu__link': true,
        'mlb-header__login-menu__link--button': useInlineLogout
      }),
      children: locale === 'es' ? 'Cerrar sesión' : 'Log out',
      key: 'logout',
      tabIndex: isLoginMenuOpen ? '0' : '1',
      onKeyDown: handleKeyDown
    };
    var children = commonProps.children,
      props = _objectWithoutProperties(commonProps, _excluded);
    if (useInlineLogout) {
      return /*#__PURE__*/React.createElement("button", _extends({}, props, {
        onClick: onLogout
      }), children);
    }
    var href = generateUrl({
      basePath: '/logout',
      clubPath: clubPath,
      lang: locale,
      queryString: "?redirectUri=".concat(((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) || '/'),
      rootRelative: true
    });
    return /*#__PURE__*/React.createElement("a", _extends({}, props, {
      href: href
    }), children);
  };
  return /*#__PURE__*/React.createElement("nav", {
    className: loginMenuClasses,
    "aria-label": "Account Navigation",
    "aria-hidden": !isLoginMenuOpen
  }, /*#__PURE__*/React.createElement("ul", {
    "aria-label": "Account Navigation"
  }, ACCOUNT_LINKS.map(function (_ref2, idx) {
    var enCopy = _ref2.enCopy,
      esCopy = _ref2.esCopy,
      link = _ref2.link;
    return /*#__PURE__*/React.createElement("li", {
      key: link
    }, /*#__PURE__*/React.createElement("a", {
      className: "mlb-header__login-menu__link",
      href: link,
      ref: idx === 0 ? firstMenuLink : null,
      tabIndex: isLoginMenuOpen ? '0' : '1',
      onKeyDown: handleKeyDown
    }, locale === 'es' ? esCopy : enCopy));
  }), renderLogout()));
};
export default LoginMenu;
LoginMenu.propTypes = {
  clubId: PropTypes.string,
  isClub: PropTypes.bool,
  isLoginMenuOpen: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  mouseLeaveHandler: PropTypes.func,
  onLogout: PropTypes.func,
  useInlineLogout: PropTypes.bool
};